import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import SEO from '../SEO.js';
import './ServicePages.css';

const DoctorConsultation = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      if (button.classList.contains('book-now-hero-btn') || button.classList.contains('sidebar-book-btn') || button.classList.contains('cta-button')) {
        button.style.backgroundColor = 'var(--primary-color)';
        button.style.border = 'none';
        button.style.color = 'var(--white-color)';
      }
    });
  };

  const benefits = [
    'Convenience of doctor visits at home',
    'No waiting time or exposure to other patients',
    'Personalized attention in a comfortable environment',
    'Reduced stress for elderly and mobility-challenged patients',
    'Comprehensive medical evaluation',
    'Follow-up care and prescription management'
  ];

  const specialties = [
    {
      name: 'General Physician',
      description: 'Primary healthcare for common illnesses, preventive care, and health maintenance.'
    },
    {
      name: 'Pediatrician',
      description: 'Specialized care for infants, children, and adolescents.'
    },
    {
      name: 'Geriatrician',
      description: 'Focused care for elderly patients with age-related health concerns.'
    },
    {
      name: 'Specialist Consultation',
      description: 'Access to cardiologists, neurologists, orthopedics, and other specialists as needed.'
    }
  ];

  return (
    <div className="service-page doctor-consultation-page">
      <SEO 
        title="Doctor Consultation at Home in Bangalore"
        description="Expert doctor consultation at home in Bangalore. Our qualified physicians provide medical assessment, prescriptions, and follow-up care at your doorstep."
        keywords="doctor home visit Bangalore, doctor consultation at home, general physician home visit, home doctor service, medical consultation at home"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Doctor Consultation Services</h1>
                <p>Expert medical consultation in the comfort of your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/doctor-consult.jpg" alt="Doctor Consultation Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Professional Doctor Consultations at Home</h2>
              <p>
                Our doctor home visit service brings qualified physicians directly to your doorstep, providing 
                comprehensive medical care without the hassle of traveling to a clinic or hospital. This service 
                is especially valuable for patients who find it difficult to leave home due to illness, mobility 
                issues, or other constraints.
              </p>
              <p>
                Our doctors are equipped with portable diagnostic tools and can perform thorough examinations, 
                prescribe medications, recommend treatments, and provide medical advice tailored to your specific 
                health needs. They work in coordination with your regular healthcare providers to ensure continuity of care.
              </p>
              
              <h3>Available Medical Specialties</h3>
              <Row className="treatment-cards">
                {specialties.map((specialty, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{specialty.name}</Card.Title>
                        <Card.Text>{specialty.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our Doctor Visits Include</h3>
              
            </div>
            <ul className="service-list">
                <li>Comprehensive physical examination</li>
                <li>Diagnosis and treatment of acute illnesses</li>
                <li>Management of chronic conditions</li>
                <li>Prescription of medications</li>
                <li>Basic diagnostic tests</li>
                <li>Health education and preventive care advice</li>
                <li>Referrals to specialists when necessary</li>
                <li>Follow-up consultations as needed</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Home Doctor Visits</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Book a Doctor Visit
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Doctor Service?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Qualified and experienced physicians</li>
                    <li>Prompt scheduling and timely visits</li>
                    <li>Comprehensive medical care</li>
                    <li>Digital health records for continuity</li>
                    <li>24/7 availability for urgent needs</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need a Doctor's Consultation?</h3>
              <p>Our qualified physicians are ready to provide expert medical care in your home.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Doctor Visit
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Doctor Consultation"
      />
    </div>
  );
};

export default DoctorConsultation;
